export default __webpack_public_path__ + "static/media/offerSlides3.b697d44d.png";